<template>
	<v-sheet elevation="0">
		<!-- <FunctionTitle :title="mainTitle" /> -->
		<CommonFlame :title="pageTitle" class="mt-2">
			<v-row no-gutters :class="$vuetify.breakpoint.xs ? 'mt-2' : ''">
				<!-- <h3 class="text-h6 font-weight-bold">製品検索</h3> -->
				<v-spacer />
			</v-row>

			<v-sheet elevation="0">
				<v-row no-gutters class="mt-2">
					<v-col cols="8" sm="3">
						<v-select
							v-if="!initialLoadingFlag"
							v-model="largeProcessType"
							label="対象工程を選択してください"
							class="mt-4"
							hint="工程を選択してください"
							outlined
							required
							dense
							:items="large_process_types"
							item-text="name"
							item-value="id"
							@change="searchLargeProcesses"
						>
						</v-select>
					</v-col>
					<v-col cols="12">
						<v-row no-gutters justify="center" class="my-3">
							<v-progress-circular
								value="40"
								width="3"
								v-if="initialLoadingFlag"
								indeterminate
							></v-progress-circular>
						</v-row>
					</v-col>
				</v-row>
				<v-row v-if="authority == 'editable' && $vuetify.breakpoint.xs" no-gutters justify="end">
					<v-btn @click="addCalendarDialog = true" class="ml-auto mb-2" color="secondary" dense>
						<v-icon class="mr-2">mdi-pencil</v-icon>
						工程データ作成</v-btn
					>
				</v-row>
			</v-sheet>
			<v-divider />
			<template v-if="authority == 'editable' && !$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn @click="addCalendarDialog = true" class="ml-auto mr-2" color="primary" dense>
					<v-icon class="mr-2">mdi-pencil</v-icon>
					工程データ作成</v-btn
				>
			</template>
			<Calendar
				ref="calendar"
				:options="options"
				:authority="authority"
				:calenderLoading.sync="calenderLoading"
				@open="OpenDialog($event)"
				@resize="updateOrderIndividualInfo($event)"
				@cross="updateOrderIndividualInfo($event)"
				@open-dialog="openShowDialog($event)"
				@next-data="makeEvent($event)"
			>
				<template v-if="situations" v-slot:calendar-top-area>
					<v-row justify="end" no-gutters>
						<div
							v-for="(situation, i) in situations"
							class="px-1 text-body-2 mt-sm-0 mt-2"
							:key="i"
						>
							<span :style="{ color: situation.color }"> ● </span>
							{{ situation.name }}
						</div>
					</v-row>
				</template>
			</Calendar>

			<LargeProcessNewDialog
				v-if="authority == 'editable'"
				ref="new_dialog"
				:dialog.sync="addCalendarDialog"
				:large_process_types="large_process_types"
				:order_individual_info.sync="order_individual_info"
				:largeProcessType="largeProcessType"
				:maxWidth="maxWidth"
				:toolbarTitle="newForm.toolbarTitle"
				:plannedStartDate="startDate"
				:plannedEndDate="endDate"
				:current_company_name="current_company_name"
				@create-process="addEvent($event)"
			/>
			<LargeProcessShowDialog
				ref="show"
				:large_process_types="large_process_types"
				@update-large-process="updateEvent($event)"
			/>
			<ScheduleArrangementUserEditDialog
				:id="schedule_arrangement_user_id"
				:dialog.sync="scheduleArrangementUserEditDialog"
			/>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"

import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import Calendar from "../shared/Calendar.vue"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import moment from "moment/min/moment.min.js"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
		Calendar,
		LargeProcessNewDialog: () => import("../large_process/components/LargeProcessNewDialog.vue"),
		LargeProcessShowDialog: () => import("../large_process/LargeProcessShowDialog.vue"),
		ScheduleArrangementUserEditDialog: () =>
			import("../large_process/components/ScheduleArrangementUserEditDialog.vue"),
	},
	data() {
		return {
			initialLoadingFlag: true,
			common: common,
			mainTitle: "製品",
			pageTitle: "工程カレンダー",
			newForm: {
				toolbarTitle: "工程データ作成",
			},
			editForm: {
				toolbarTitle: "工程データ編集",
				requiredFetch: true,
			},
			maxWidth: "900px",
			authority: null,
			largeProcesses: [],
			large_process_types: [],
			largeProcessType: null,
			largeProcessTypeValue: null,
			addCalendarDialog: false,
			clickDate: null,
			startDate: null,
			endDate: null,
			schedule_arrangement_user_id: null,
			scheduleArrangementUserEditDialog: false,
			order_individual_info: null,
			// order_individual_infos: [],
			errors: [],
			options: {
				isShowDropArea: false,
				events: [],
				dragItems: [],
				url: "/erp/v1/search_large_processes",
				params: {
					large_process_type_id: this.$route.query.large_process_type_id,
				},
				isFetchData: false,
			},
			isChangeConfirmationStatus: false,
			schedule_arrangement_user: null,
			month: moment().format("YYYY-MM"),
			thisMonth: moment().format("YYYY-MM"),
			calenderLoading: true,
		}
	},
	mounted() {
		this.fetchLargeProcessTypes()
		if (this.$route.query.large_process_type_id) {
			this.largeProcessType = Number(this.$route.query.large_process_type_id)
			this.fetchLargeProcesses()
		}
		if (this.$route.query.schedule_arrangement_user_id) {
			this.schedule_arrangement_user_id = Number(this.$route.query.schedule_arrangement_user_id)
			this.scheduleArrangementUserEditDialog = true
		}
	},
	methods: {
		openShowDialog(id) {
			this.$refs.show.openDialog(id)
		},
		resetDialog() {
			this.addCalendarDialog = false
			this.startDate = null
			this.endDate = null
			this.order_individual_info = null
			this.errors = []
		},
		searchLargeProcesses() {
			this.fetchLargeProcesses()
			this.$router.push({
				name: this.$route.name,
				query: {
					large_process_type_id: this.largeProcessType,
				},
			})
		},
		fetchLargeProcesses() {
			this.calenderLoading = true
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_large_processes", {
					headers,
					params: { large_process_type_id: this.largeProcessType, month: this.month },
				})
				.then((res) => {
					this.largeProcesses = res.data
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
				.finally(() => (this.calenderLoading = false))
		},
		OpenDialog(event) {
			this.clickDate = moment(event).format("YYYY-MM-DD")
			this.startDate = this.clickDate
			this.addCalendarDialog = true
		},
		fetchLargeProcessTypes() {
			this.initialLoadingFlag = true
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/large_process_types", { headers })
				.then((res) => {
					this.authority = res.data.authority
					this.large_process_types = res.data.large_process_types
					this.current_company_name = res.data.current_company_name
					this.initialLoadingFlag = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updateOrderIndividualInfo(event) {
			const headers = authenticate.setHeader()
			const elapsedSeconds = event.datetime.end.setDate(event.datetime.end.getDate() - 1)
			const endDate = new Date(elapsedSeconds)

			axios
				.put(
					`/erp/v1/large_processes/${event.id}`,
					{
						large_process: {
							planned_start_date: event.datetime.start,
							planned_end_date: endDate,
						},
					},
					{ headers }
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "日程を更新しました。",
					})
					this.updateEvent(res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		colorByFilledTime(largeProcess) {
			if (largeProcess?.schedule_arrangement) {
				const scheduleArrangement = largeProcess.schedule_arrangement
				if (largeProcess.situation == "completion") {
					// 完了
					return this.$vuetify.theme.themes.light.process.completion
				} else if (scheduleArrangement.planned_start_time && scheduleArrangement.planned_end_time) {
					// スケジュール決定済み
					return this.$vuetify.theme.themes.light.process.schedule_confirmed
				} else if (scheduleArrangement) {
					// 未定
					return this.$vuetify.theme.themes.light.process.schedule_arranging
				}
			} else {
				return this.$vuetify.theme.themes.light.process.schedule_noting // TODO
			}
		},
		sinceOneDay(end_date) {
			// FullCalendarイベントのendの表示が終了日時 -1となっているため、1日すすめる
			const parseDate = new Date(Date.parse(end_date))
			const elapsedSeconds = parseDate.setDate(parseDate.getDate() + 1)
			const date = new Date(elapsedSeconds)
			const endDate = moment(date).format("YYYY-MM-DDTHH:mm")
			return endDate
		},
		makeEvent(large_processes) {
			this.options.events = []
			const largeProcessType = this.large_process_types.find((l) => l.id === this.largeProcessType)
			if (largeProcessType && largeProcessType.schedule_arrangement_flag) {
				large_processes.forEach((large_process) => {
					const endDate = this.sinceOneDay(large_process.schedule_arrangement.planned_end_time)
					let event = {
						id: large_process.id,
						title: common.productNameWithProductNumber(large_process.order_individual_info),
						start: large_process.schedule_arrangement.planned_start_time,
						end: endDate,
						allDay: true,
						backgroundColor: this.colorByFilledTime(large_process),
					}
					this.options.events.push(event)
					this.removeDuplicationEvent(this.options.events)
				})
			} else {
				large_processes.forEach((large_process) => {
					const endDate = this.sinceOneDay(large_process.planned_end_date)
					let event = {
						id: large_process.id,
						title: common.productNameWithProductNumber(large_process.order_individual_info),
						start: large_process.planned_start_date,
						end: endDate,
						allDay: true,
					}
					this.options.events.push(event)
					this.removeDuplicationEvent(this.options.events)
				})
			}
		},
		addEvent(e) {
			let event = {}
			if (e.schedule_arrangement_flag) {
				const endDate = this.sinceOneDay(e.large_process.schedule_arrangement.planned_end_time)
				event = {
					id: e.large_process.id,
					title: common.productNameWithProductNumber(e.large_process.order_individual_info),
					start: e.large_process.schedule_arrangement.planned_start_time,
					end: endDate,
					allDay: true,
					backgroundColor: this.colorByFilledTime(e.large_process),
				}
			} else {
				const endDate = this.sinceOneDay(e.large_process.planned_end_date)
				event = {
					id: e.large_process.id,
					title: common.productNameWithProductNumber(e.large_process.order_individual_info),
					start: e.large_process.planned_start_date,
					end: endDate,
					allDay: true,
				}
			}
			this.options.events.push(event)
		},
		updateEvent(large_process) {
			if (large_process.large_process_type.schedule_arrangement_flag) {
				const endDate = this.sinceOneDay(large_process.schedule_arrangement.planned_end_time)
				this.options.events.forEach((event) => {
					if (event.id == large_process.id) {
						event["start"] = large_process.schedule_arrangement.planned_start_time
						event["end"] = endDate
					}
				})
			} else {
				const endDate = this.sinceOneDay(large_process.planned_end_date)
				this.options.events.forEach((event) => {
					if (event.id == large_process.id) {
						event["start"] = large_process.planned_start_date
						event["end"] = endDate
					}
				})
			}
		},
		removeDuplicationEvent(events) {
			this.options.events = events.filter((event, index, array) => {
				return array.findIndex((v) => event.title === v.title) === index
			})
		},
	},
	computed: {
		situations() {
			if (this.largeProcessType?.schedule_arrangement_flag) {
				return [
					{
						name: "予定時間未決定",
						color: this.$vuetify.theme.themes.light.process.schedule_arranging,
					},
					{
						name: "予定時間決定済み",
						color: this.$vuetify.theme.themes.light.process.schedule_confirmed,
					},
					{ name: "工程完了", color: this.$vuetify.theme.themes.light.process.completion },
				]
			} else {
			}
		},
	},
	watch: {
		largeProcesses(newVal) {
			this.makeEvent(newVal)
		},
		large_process_types(newVal) {
			this.makeEvent(this.largeProcesses)
		},
		deep: true,
	},
}
</script>
